import React from 'react';
import { LabelInput } from '@/components/ui/inputs/LabelInput';
import { TextArea } from '@/components/ui/inputs/TextArea';
import { IconScout } from '@/components/ui/images/IconScout';
import { useTranslation } from '@/i18n';
import type { IncidentDetail } from '@/api/domains/employeeIncident';
import { SidePanelFormLayout } from '@/components/layout';


export interface IncidentDetailFormProps {
  incident?: IncidentDetail | null;
  error?: boolean;
}

const IncidentDetailForm: React.FC<IncidentDetailFormProps> = ({ incident, error }) => {
  const { t: translate } = useTranslation('attendance');

  if (error) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-red-600">{translate('incidents.errors.loadDetailFailed')}</p>
      </div>
    );
  }

  if (!incident) {
    return (
      <div className="flex items-center justify-center p-8">
        <p className="text-gray-500">{translate('incidents.detail.noData')}</p>
      </div>
    );
  }

  return (
    <SidePanelFormLayout>
      <SidePanelFormLayout.Fields>
        <LabelInput
          label={translate('incidents.detail.id')}
          value={String(incident.id)}
          disabled
        />

        <LabelInput
          label={translate('incidents.detail.errorType')}
          value={incident.errorType}
          disabled
        />

        <LabelInput
          label={translate('incidents.detail.incidentDate')}
          value={incident.incidentDate}
          disabled
          iconRight={<IconScout name="calendarAlt" size="sm" />}
        />

        <LabelInput
          label={translate('incidents.detail.checkInDate')}
          value={incident.checkInDate}
          disabled
          iconRight={<IconScout name="calendarAlt" size="sm" />}
        />

        <LabelInput
          label={translate('incidents.detail.checkInTime')}
          value={incident.checkInTime}
          disabled
          iconRight={<IconScout name="clockThree" size="sm" />}
        />

        <LabelInput
          label={translate('incidents.detail.event')}
          value={incident.event}
          disabled
        />

        <LabelInput
          label={translate('incidents.detail.location')}
          value={incident.location}
          disabled
        />

        <LabelInput
          label={translate('incidents.detail.updatedAt')}
          value={incident.updatedAt}
          disabled
          iconRight={<IconScout name="calendarAlt" size="sm" />}
        />

        <LabelInput
          label={translate('incidents.detail.status')}
          value={incident.status}
          disabled
        />

        <TextArea
          label={`${translate('incidents.detail.employeeComment')}`}
          value={incident.employeeComment || ''}
          placeholder={translate('incidents.detail.commentPlaceholder')}
          disabled
          showCharacterCount
          maxLength={100}
          rows={3}
        />

        <TextArea
          label={`${translate('incidents.detail.updateComment')}`}
          value={incident.updateComment || ''}
          placeholder={translate('incidents.detail.commentPlaceholder')}
          disabled
          showCharacterCount
          maxLength={100}
          rows={3}
        />
      </SidePanelFormLayout.Fields>
    </SidePanelFormLayout>
  );
};

export default IncidentDetailForm;
